"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _antd = require("antd");

var _configProvider = require("antd/lib/config-provider");

var _ConfigProvider$Confi;

var MergedConfigConsumer = (_antd.ConfigProvider === null || _antd.ConfigProvider === void 0 ? void 0 : (_ConfigProvider$Confi = _antd.ConfigProvider.ConfigContext) === null || _ConfigProvider$Confi === void 0 ? void 0 : _ConfigProvider$Confi.Consumer) || _configProvider.ConfigConsumer;
var _default = MergedConfigConsumer;
exports.default = _default;